<template>
  <div class='control-section'>
    <div id='networkDiagram'>
      <!-- 添加网元对话框 -->
      <CustomDialog
        ref='nedialog'
        :element='neDialog.element'
        :styles='neDialog.styles'
        :messages='neDialog.messages'
      >
        <template v-slot:dialog-content>
          <add-ne ref='addne' @close='cancelNe'></add-ne>
        </template>
      </CustomDialog>
      <!-- 添加子网对话框 -->
      <CustomDialog
        ref='subnetDialog'
        :subNodes='nodesMap'
        :element='subnetDialog.element'
        :styles='subnetDialog.styles'
        :messages='subnetDialog.messages'
      >
        <template v-slot:dialog-content>
          <add-subnet ref='addsubnet' :type='type' @close='cancelSubnet' @setSubnetInfo='getNeData'></add-subnet>
        </template>
      </CustomDialog>
      <!-- 修改子网弹框 -->
      <CustomDialog
        ref='updateSubnetDialog'
        :subNodes='nodesMap'
        :element='upSubnetDialog.element'
        :styles='upSubnetDialog.styles'
        :messages='upSubnetDialog.messages'
      >
        <template v-slot:dialog-content>
          <update-subnet ref='updateSubnet' :type='type' @close='cancel2Subnet'></update-subnet>
        </template>
      </CustomDialog>
      <!-- 添加集群对话框 -->
      <CustomDialog
        ref='trunkDialog'
        :element='trunkDialog.element'
        :styles='trunkDialog.styles'
        :messages='trunkDialog.messages'
      >
        <template v-slot:dialog-content>
          <add-trunk ref='addtrunk' @close='closeTrunk'></add-trunk>
        </template>
      </CustomDialog>

      <div id='diagram-space' class='sb-mobile-diagram'>
        <ejs-diagram
          style='display:block'
          ref='diagramObj'
          id='diagram'
          :nodes='nodes'
          :doubleClick='doubleClick'
          :selectionChange='selectionChange'
          :pageSettings='pageSettings'
          :scrollSettings='scrollSettings'
          :contextMenuSettings='contextMenuSettings'
          :contextMenuClick='contextMenuClick'
          :contextMenuOpen='contextMenuOpen'
          :width='width'
          :height='height'
        >
          <!-- '网元图例展示' -->
          <template>
            <NetTypeShow></NetTypeShow>
          </template>
          <!-- 面板信息展示 -->
          <template>
            <PanelBoardShow :alarmShowObj='alarmShowObj'></PanelBoardShow>
          </template>
        </ejs-diagram>
      </div>
    </div>
  </div>
</template>
<style>
</style>

<script>
import Vue from 'vue';
import {
  Node,
  DiagramPlugin,
  SymbolPalettePlugin,
  Diagram,
  NodeConstraints,
  DiagramConstraints,
  DiagramContextMenu,
  AnnotationConstraints
} from '@syncfusion/ej2-vue-diagrams';
import { UploaderPlugin } from '@syncfusion/ej2-vue-inputs';
import { ButtonPlugin } from '@syncfusion/ej2-vue-buttons';
import { createNamespacedHelpers } from 'vuex';
import CustomDialog from '../common/CustomDialog';
import AddNe from './AddNe';
import NetTypeShow from './NetTypeShow';
import PanelBoardShow from './PanelBoardShow';
import AddSubnet from './AddSubnet';
import UpdateSubnet from './UpdateSubnet';
import AddTrunk from './AddTrunk';
import topoMethods from './TopoCommon';

const { mapActions } = createNamespacedHelpers('topoConfig');
const template6 = '<g xmlns="http://www.w3.org/2000/svg" id="MSO" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">  <path id="Stroke-61" stroke="#5C90DF" stroke-width="1" fill="none" d="M7.7,11.2C8,10.5,8.5,9.8,9,9.1c1,0.7,2.2,1.2,3.5,1.6c0,0.2,1.3,0.4,1.3,0.3c0.7,0.1,1.5,0.2,2.3,0.2h0.1c0.8,0,1.5-0.1,2.3-0.2c0,0.1,1.3-0.1,1.3-0.3c1.3-0.4,2.4-0.9,3.5-1.6c0.5,0.6,1,1.3,1.4,2.1h1.5c-1.6-3.9-5.4-6.7-9.9-6.7s-8.3,2.8-9.9,6.7H7.7z M22.3,8.2c-0.8,0.5-1.8,0.9-2.8,1.2c-0.3-1.3-0.8-2.5-1.3-3.3C19.8,6.5,21.1,7.2,22.3,8.2z M16.1,5.9c0.5,0,1.4,1.3,2.1,3.8c-0.7,0.1-1.4,0.2-2.1,0.2c-0.7,0-1.4-0.1-2.1-0.2C14.7,7.2,15.6,5.9,16.1,5.9z M14,6.1c-0.5,0.8-0.9,2-1.3,3.3c-1-0.3-1.9-0.7-2.8-1.2C11.1,7.2,12.5,6.5,14,6.1z"/>  '
  + '<path d="M24.6,21.3c-0.4,0.8-0.8,1.5-1.4,2.1c-1-0.7-2.2-1.2-3.5-1.6c0-0.2-1.3-0.4-1.3-0.3c-0.7-0.1-1.5-0.2-2.3-0.2h-0.1c-0.8,0-1.6,0.1-2.3,0.2c0-0.1-1.3,0.1-1.3,0.3c-1.3,0.4-2.4,0.9-3.5,1.6c-0.5-0.6-1-1.3-1.4-2.1H6.2c1.6,3.9,5.4,6.7,9.9,6.7c4.5,0,8.3-2.8,9.9-6.7H24.6z M10,24.3c0.8-0.5,1.8-0.9,2.8-1.2c0.3,1.3,0.8,2.5,1.3,3.3C12.5,26,11.1,25.3,10,24.3z M16.1,26.6c-0.5,0-1.4-1.3-2.1-3.8c0.7-0.1,1.4-0.2,2.1-0.2c0.7,0,1.4,0.1,2.1,0.2C17.6,25.3,16.6,26.6,16.1,26.6z M18.2,26.4c0.5-0.8,0.9-2,1.3-3.3c1,0.3,1.9,0.7,2.8,1.2C21.1,25.3,19.8,26,18.2,26.4z" id="Stroke-84" stroke="#5C90DF" stroke-width="1" fill="none"/> '
  + '<polygon id="Fill-81" stroke="#5C90DF" fill="none" points="9.3,17.3 6.5,12.7 4.6,12.7 3.9,19.8 5.8,19.8 6.2,15.2 9.1,19.8 10.9,19.8 11.6,12.7 9.8,12.7"/>  <polygon id="Fill-81" stroke="#5C90DF" fill="none" points="20.5,12.7 18.7,12.7 16.8,17.1 15.7,12.7 13.9,12.7 13.9,12.7 13,12.7 12.3,19.8 14.1,19.8 14.6,15.5 15.6,19.8 15.6,19.8 15.6,19.8 17.5,19.8 17.5,19.8 17.5,19.8 19.3,15.5 18.9,19.8 20.8,19.8 21.4,12.7 20.5,12.7"/> '
  + '<path d="M27,16.1c-0.9-0.5-2.8-0.8-2.7-1.6c0-0.5,0.8-0.7,1.5-0.7c1.2,0,2.3,0.3,2.3,0.3l0.1-1.3c0,0-1.1-0.2-2.8-0.2c-2,0-3.1,1.1-3.2,1.9c-0.1,0.8,0.3,1.3,0.7,1.7C24,17,26,17.2,26,17.9c0,0.4-0.5,0.6-1.2,0.6c-1,0-2.5-0.4-2.5-0.4l-0.1,1.5c0,0,1.2,0.2,2.9,0.2c2,0,3.2-0.9,3.3-1.9C28.3,17,27.6,16.5,27,16.1z" id="Stroke-84" stroke="#5C90DF" stroke-width="1" fill="none"/> </g>';

Diagram.Inject(DiagramContextMenu);
Vue.use(DiagramPlugin);
Vue.use(SymbolPalettePlugin);
Vue.use(UploaderPlugin);
Vue.use(ButtonPlugin);

let diagramInstance;

export default {
  name: 'base-logic',
  components: {
    CustomDialog,
    PanelBoardShow,
    AddNe,
    NetTypeShow,
    AddSubnet,
    UpdateSubnet,
    AddTrunk
  },
  created() {
    this.nodes = this.loadGraph(this.isLogical);
  },
  mixins: [topoMethods],
  props: [
    'slecteMessage',
    'dataSource',
    'message',
  ],
  watch: {
    nodes(newVal) {
      this.nodes = newVal;
      console.log('nodesnew', this.nodes);
    },

    slecteMessage() {
      const nodeIndex = diagramInstance.nodes.findIndex(
        v => v.id === this.slecteMessage
      );
      if (nodeIndex !== -1) {
        const nodearray = [];
        nodearray.push(diagramInstance.nodes[nodeIndex]);
        diagramInstance.select(nodearray);
      }
    },
    message() {
      const nodeIndex = diagramInstance.nodes.findIndex(
        v => v.id === `n${this.message}`
      );
      if (nodeIndex !== -1) {
        const nodearray = [];
        nodearray.push(diagramInstance.nodes[nodeIndex]);
        diagramInstance.select(nodearray);
      } else {
        this.nodesMap.forEach((val, key) => {
          if (`n${this.message}` === key) {
            const childId = this.nodesMap.get(key).parentid;
            // 双击网元入栈,为返回上一层做准备
            if (this.nodesGrage.length === 0 || this.nodesCache[this.nodesCache.length - 1] !== childId) {
              this.nodesGrage.push(childId);
              const arr = [];
              this.nodes.forEach((value, index, array) => {
                arr.push(array[index].id);
              });
              this.nodesCache.push(arr);
            }
            // 加载下一层
            const array = this.findChildren(childId);
            if (array.length > 0) {
              this.$emit('changeNode', array);
            }
            diagramInstance.clear();
            diagramInstance = this.$refs.diagramObj.ej2Instances;
            const nIndex = diagramInstance.nodes.findIndex(
              v => v.id === key
            );
            if (nIndex !== -1) {
              const nodearray = [];
              nodearray.push(diagramInstance.nodes[nIndex]);
              diagramInstance.select(nodearray);
            }
          }
        });
      }
    }
  },
  data() {
    return {
      type: 0, // 逻辑视图子网类型:0
      isLogical: true, // 逻辑视图
      alarmShowObj: { seeObj: false, seeBottomObj: false, idObj: '' },
      nodeName: '',
      nodeId: '',
      width: '100%',
      height: 'calc(100vh - 140px)',
      see: false,
      seeBottom: false,
      selectNe: '',
      showNetType: false,
      constraints:
        DiagramConstraints.Default & ~DiagramConstraints.Virtualization,
      tooltip: {
        content: 'tooltip',
        position: 'TopRight',
        relativeMode: 'Object',
        showTipPointer: false
      },
      contextMenuSettings: {
        show: true,
        items: [
          { text: '新增网元', id: 'addNe' },
          { text: '新增集群', id: 'addCluster' },
          { text: '新增子网', id: 'addSubnet' },
          { text: '编辑网元', id: 'editNe' },
          { text: '编辑集群', id: 'editCluster' },
          { text: '编辑子网', id: 'editSubnet' },
          { text: '删除网元', id: 'delNe' },
          { text: '删除集群', id: 'delCluster' },
          { text: '删除子网', id: 'delSubnet' }
        ],
        showCustomMenuOnly: true
      },
      contextMenuOpen: args => {
        const childList = args.element.querySelectorAll('li.e-menu-item');
        const node = diagramInstance.selectedItems.nodes[0];
        if (diagramInstance.selectedItems.nodes.length > 1) {
          childList.style.display = 'none';
        } else if (node && (node.type === 0 || node.type === 1)) { // 右击子网时
          childList[0].style.display = 'none';
          childList[1].style.display = 'none';
          childList[2].style.display = 'none';
          childList[3].style.display = 'none';
          childList[4].style.display = 'none';
          childList[5].style.display = 'block';
          childList[6].style.display = 'none';
          childList[7].style.display = 'none';
          childList[8].style.display = 'block';
        } else if (node && node.type > 1 && node.type < 10000) { // 右击网元
          childList[0].style.display = 'none';
          childList[1].style.display = 'none';
          childList[2].style.display = 'none';
          childList[3].style.display = 'block';
          childList[4].style.display = 'none';
          childList[5].style.display = 'none';
          childList[6].style.display = 'block';
          childList[7].style.display = 'none';
          childList[8].style.display = 'none';
        } else if (node && node.type >= 10000) {
          childList[0].style.display = 'none';
          childList[1].style.display = 'none';
          childList[2].style.display = 'none';
          childList[3].style.display = 'none';
          childList[4].style.display = 'block';
          childList[5].style.display = 'none';
          childList[6].style.display = 'none';
          childList[7].style.display = 'block';
          childList[8].style.display = 'none';
        } else { // 右击空白
          childList[0].style.display = 'block';
          childList[1].style.display = 'block';
          childList[2].style.display = 'block';
          childList[3].style.display = 'none';
          childList[4].style.display = 'none';
          childList[5].style.display = 'none';
          childList[6].style.display = 'none';
          childList[7].style.display = 'none';
          childList[8].style.display = 'none';
        }
      },
      contextMenuClick: args => {
        if (args.item.id === 'addNe') {
          this.$refs.nedialog.show();
          this.$refs.addne.queryNeType();
        } else if (args.item.id === 'addSubnet') {
          this.$refs.addsubnet.initData(this.type);
          this.$refs.subnetDialog.show();
        } else if (args.item.id === 'addCluster') {
          this.$refs.trunkDialog.show();
        } else if (
          args.item.id === 'delCluster' || args.item.id === 'delSubnet'
        ) {
          const node = diagramInstance.selectedItems.nodes[0];
          if (node) {
            this.deleteNe(node.id, node.type);
          }
        } else if (args.item.id === 'editSubnet') {
          const node = diagramInstance.selectedItems.nodes[0];
          this.$refs.updateSubnet.initData(node, this.type);
          this.$refs.updateSubnetDialog.show();
        }
      },
      pageSettings: {
        scrollLimit: 'Page',
        boundaryConstraints: 'diagram'
        // showPageBreaks:false,
        // width:1560,
        // height:806,
      },
      element: {
        target: '#app',
        refName: 'add',
        isClose: true
      },
      scrollSettings: {
        canAutoScroll: false,
        scrollLimit: 'Diagram',
        horizontalOffset: 0,
        verticalOffset: 0,
        currentZoom: 1,
        maxZoom: 1.2,
        minZoom: 0.1
      },
      click() {
        this.seeBottom = !this.seeBottom;
      },

      selectionChange: args => {
        console.log('args', args);
        if (args.type === 'Addition' && args.state === 'Changed' && args.newValue.length === 1) {
          console.log('args.newValue', args.newValue);
          const node = diagramInstance.nodes[
            diagramInstance.nodes.findIndex(v => v.id === args.newValue[0].id)
          ];
          this.sendMessage(
            parseInt(
              args.newValue[0].id.substring(1, args.newValue[0].id.length),
              10
            )
          );
          // this.nodeName = node.annotations[0].content;
          this.nodeId = node.id.substring(1, args.newValue[0].id.length);
          this.alarmShowObj.seeObj = true;
          this.alarmShowObj.seeBottomObj = true;
          this.alarmShowObj.idObj = this.nodeId;
        } else {
          this.alarmShowObj.seeObj = false;
          this.alarmShowObj.seeBottomObj = false;
        }
      },
      // 添加网元对话框
      neDialog: {
        element: {
          target: '#app',
          title: '添加网元',
          isClose: true,
          refName: '网元管理',
          buttonGroup: [
            {
              click: this.submitNe,
              buttonModel: {
                content: this.$t('Alarm.confirm'),
                isPrimary: true
              }
            },
            {
              click: this.cancelNe,
              buttonModel: { content: this.$t('Alarm.cancel') }
            }
          ]
        },
        styles: {
          width: '800px',
          height: '700px',
          visible: false,
          model: true
        },
        messages: {
          title: '添加网元'
        }
      },
      // 添加子网对话框
      subnetDialog: {
        element: {
          title: '添加子网',
          target: '#app',
          isClose: true,
          refName: '子网管理',
          buttonGroup: [
            {
              click: this.submitSubnet,
              buttonModel: {
                content: this.$t('Alarm.confirm'),
                isPrimary: true
              }
            },
            {
              click: this.cancelSubnet,
              buttonModel: { content: this.$t('Alarm.cancel') }
            }
          ]
        },
        styles: {
          width: '500px',
          height: '650px',
          visible: false,
          model: true
        },
        messages: {
          title: '添加子网'
        }
      },
      // 修改子网对话框
      upSubnetDialog: {
        element: {
          title: '修改子网',
          target: '#app',
          isClose: true,
          refName: '子网管理',
          buttonGroup: [
            {
              click: this.update2Subnet,
              buttonModel: {
                content: this.$t('Alarm.confirm'),
                isPrimary: true
              }
            },
            {
              click: this.cancel2Subnet,
              buttonModel: { content: this.$t('Alarm.cancel') }
            }
          ]
        },
        styles: {
          width: '800px',
          height: '650px',
          visible: false,
          model: true
        },
        messages: {
          title: '修改子网'
        }
      },
      // 添加集群对话框
      trunkDialog: {
        element: {
          target: '#app',
          isClose: true,
          refName: '集群管理',
          buttonGroup: [
            {
              click: this.submitTrunk,
              buttonModel: {
                content: this.$t('Alarm.confirm'),
                isPrimary: true
              }
            },
            {
              click: this.closeTrunk,
              buttonModel: { content: this.$t('Alarm.cancel') }
            }
          ]
        },
        styles: {
          width: '800px',
          height: '700px',
          visible: false,
          model: true
        },
        messages: {
          title: '添加集群'
        }
      }
    };
  },
  mounted() {
    diagramInstance = this.$refs.diagramObj.ej2Instances;
    delete diagramInstance.commands.delete;
    delete diagramInstance.commands.copy;
    delete diagramInstance.commands.paste;
    delete diagramInstance.commands.cut;
  },
  methods: {
    ...mapActions([
      'setPhysical',
      'addPhysical',
      'delPhysicalNodes',
      'setParentNe'
    ]),
    sendMessage(NeID) {
      console.log('ggNeID1', NeID);
      this.$emit('sendInfo', NeID);
    },
    addNe(newid, newname, template1) {
      const node = {
        id: newid,
        offsetX: 120,
        offsetY: 75,
        shape: { type: 'Native', content: template1 },
        annotations: [
          { content: newname, offset: { x: 0.5, y: 0 }, margin: { bottom: 10 } }
        ],
        constraints:
          (NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize) | NodeConstraints.HideThumbs | NodeConstraints.Tooltip,
        width: 50,
        height: 65
      };
      this.nodes = diagramInstance.nodes;
      this.nodes.push(node);
    },
    // 添加网元保存
    submitNe() {
      this.$refs.addne.outputs();
    },
    cancelNe() {
      this.$refs.nedialog.close();
      this.$refs.addne.initData();
    },
    deleteNe(neId, type) {
      if (type === 0 || type === 1) {
        this.axios.post('topo/subnet/deleteSubnet', neId).then(response => {
          if (response.data.errorCode === 'SUCCESS') {
            diagramInstance.remove(diagramInstance.nodes[neId]);
            this.delPhysicalNodes(neId);
          }
        });
      } else {
        this.axios.post('topo/device/deleteDev', neId).then(response => {
          if (response.data.errorCode === 'SUCCESS') {
            diagramInstance.remove(diagramInstance.nodes[neId]);
            this.delPhysicalNodes(neId);
          }
        });
      }
    },
    // 添加子网保存
    submitSubnet() {
      this.$refs.addsubnet.outputs();
    },
    cancelSubnet() {
      this.$refs.subnetDialog.close();
      this.$refs.addsubnet.initData();
    },
    // 修改子网保存
    update2Subnet() {
      this.$refs.updateSubnet.outputs();
    },
    cancel2Subnet() {
      this.$refs.updateSubnetDialog.close();
      this.$refs.updateSubnet.initData();
    },
    // 添加集群保存
    submitTrunk() {
      this.$refs.addtrunk.outputs();
    },
    closeTrunk() {
      this.$refs.trunkDialog.close();
      this.$refs.addtrunk.initData();
    },
    // 保存坐标
    saveLoc() {
      const position = [];
      console.log('this.diagramInstance', diagramInstance);
      diagramInstance.nodes.forEach(element => {
        position.push({
          id: parseInt(element.id.substring(1, element.id.length), 10),
          coordinatex: element.offsetX,
          coordinatey: element.offsetY
        });
      });
      const params = JSON.stringify(position);
      this.axios
        .post('lte/ems/topo/savePositions.html', params)
        .then(response => {
          console.log('save complete', response);
        });
    },
    revert() {
      diagramInstance.scrollSettings.currentZoom = 1;
      diagramInstance.reset();
    },
    selectAll() {
      diagramInstance.selectAll();
    },
    excelLayout() {
      if (this.nodes.length > 0) {
        this.nodes = this.layout(this.nodes);
      }
    },
    doubleClick(args) {
      if (args.source instanceof Node) {
        console.log('双击了网元');
        const array = this.nextLayer(args, this.isLogical);
        if (array.length > 0) {
          this.nodes = array;
        }
      }
    },
    backPrevious() {
      if (this.nodes.length > 0) {
        const array = this.backPre(this.nodes[0], this.isLogical);
        if (array.length > 0) {
          this.nodes = array;
        }
      }
    },
    // 保存网元获取数据,在物理视图展示网元
    getNeData(data) {
      console.log('加子网数据:', data);
      if (data) {
        const node = {
          id: data.id,
          parentid: data.parentid,
          neType: data.netype,
          shape: { type: 'Native' },
          annotations: [
            {
              content: data.neName,
              offset: { x: 0.5, y: 0 },
              margin: { bottom: 10 },
              constraints: AnnotationConstraints.ReadOnly
            }
          ],
          constraints:
            (NodeConstraints.Default & ~NodeConstraints.Rotate & ~NodeConstraints.Resize) | NodeConstraints.HideThumbs | NodeConstraints.Tooltip,
          width: 50,
          height: 50
        };
        if (data.netype === 'subnetwork') {
          node.shape.content = template6;
        } else {
          node.shape.content = template6;
        }
        this.nodes = diagramInstance.nodes;
        this.nodes.push(node);
      }
    },
  }
};
</script>
